
import ajax from '../../assets/js/interceptor';
import util from '../../assets/js/util';
const selectMenuListURL = '/v1/funcMenu';
const selectPageCompentURL = '/v1/funcMenu/pageComponent';
const selectDataRowRuleURL = '/v1/funcMenu/dataRowRule';
const selectDataColumnRuleURL = '/v1/funcMenu/dataColRule';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    addressList: [], // 通讯录的列表
    systemList: [], // 应用列表
    pageCompDataSource: [], // 页面控件数据
    pageCompCount: 0, // 页面控件数量
    dataColumnAuthDataSource: [], // 数据列权限数据
    dataColumnAuthCount: 0,
    dataRowAuthDataSource: [], // 数据行权限数据
    dataRowAuthCount: 0
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getDataColumnAuthList ({ commit, dispatch, state }, payload) {
      ajax.get(selectDataColumnRuleURL, { params: { funcMenuId: payload.funcMenuId, pageIndex: payload.columnFilter.pageIndex, pageSize: payload.columnFilter.pageSize } }).then(
        res => {
          const { data } = res;
          if (data.code == 200) {
            const list = data.data.records;
            commit('SAVE_STATE', {
              dataColumnAuthDataSource: list, dataColumnAuthCount: data.data.records.length
            });
          }
        }
      );
    },
    getDataRowAuthList ({ commit, dispatch, state }, payload) {
      ajax.get(selectDataRowRuleURL, { params: { funcMenuId: payload.funcMenuId, pageIndex: payload.RowFilter.pageIndex, pageSize: payload.RowFilter.pageSize } }).then(
        res => {
          const { data } = res;
          if (data.code == 200) {
            const list = data.data.records;
            commit('SAVE_STATE', {
              dataRowAuthDataSource: list, dataRowAuthCount: data.data.total
            });
          }
        }
      );
    },
    // 权限控件列表请求
    getPageCompList ({ commit, dispatch, state }, payload) {
      // ajax.get(selectPageCompentURL, { params: { id: payload.id } }).then(res => {
      //   console.log(res);
      // });

      ajax.get(selectPageCompentURL, { params: { funcMenuId: payload.funcMenuId, pageIndex: payload.filter.pageIndex, pageSize: payload.filter.pageSize } }).then(res => {
        const { data } = res;
        if (data.code == 200) {
          const list = data.data.records;
          commit('SAVE_STATE', {
            pageCompDataSource: list, pageCompCount: data.data.total
          });
        }
      });
    },
    // 整理接口返回的数据
    getUserPermission ({ commit, dispatch, state }, payload) {
      // ajax.get('www.aldf.com');
    },
    getaddressList ({ commit, dispatch, state }, payload) {
      // TODO: 更新可用通讯录列表
      const data = [{ label: '91通讯录', value: 0 }];
      commit('SAVE_STATE', { addressList: data });
    },
    getTableInfo ({ commit, dispatch, state }, payload) {
      // const data = '{"code":200,"msg":"操作成功","data":[{"id":"menu_9dbc1e450936489980373517f820f17d","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"0","parentMenuName":null,"menuName":"quanxian","menuType":2,"menuCode":"234","menuStatus":1,"menuSortNum":123},{"id":"menu_1f66ef035e044bda94fc276d7c31eb94","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"","parentMenuName":null,"menuName":"阿道夫","menuType":1,"menuCode":"123","menuStatus":1,"menuSortNum":21},{"id":"menu_44fb91eabd9c418f89ed465b188634c4","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"0","parentMenuName":null,"menuName":"login","menuType":3,"menuCode":"34534","menuStatus":1,"menuSortNum":1112341},{"id":"menu_371b550d41074650a1cc79f213f4bb41","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"menu_1f66ef035e044bda94fc276d7c31eb94","parentMenuName":null,"menuName":"首位","menuType":1,"menuCode":"12333333","menuStatus":1,"menuSortNum":1},{"id":"menu_8e1aad062e9c4f12a0caf4285d6bd5f1","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"menu_1f66ef035e044bda94fc276d7c31eb94","parentMenuName":null,"menuName":"阿道夫二级","menuType":1,"menuCode":"1222","menuStatus":1,"menuSortNum":3},{"id":"menu_0b59e6f087384825b8dcfa8758b27f3c","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"menu_9dbc1e450936489980373517f820f17d","parentMenuName":null,"menuName":"quanxian2ji","menuType":2,"menuCode":"23","menuStatus":1,"menuSortNum":123}]}';
      // const json = JSON.parse(data);
      // const list = json.data;
      ajax.get(selectMenuListURL, { params: { ...payload, appId: payload.appid } }).then(res => {
        const { data } = res;
        if (data.code == 200) {
          const list = data.data;
          list.forEach(element => {
            element.selected = false;
          });
          const result = util.arrangeData(list, true, 'menuSortNum');
          let indexObj = { currentIndex: 1 };
          for (let i = 0; i < result.length; i++) {
            if (i == 0) {
              indexObj = util.preOrder(result[i], indexObj);
            } else {
              indexObj = util.preOrder(result[i], indexObj);
            }
          }
          commit('SAVE_STATE', {
            dataSource: result, totalCount: data.data.length
          });
        }
      });
    },
    getSystemList ({ commit, dispatch, state }, payload) {
      // TODO: 更新可用通讯录列表
      // const data = [{ label: '权限系统（死数据）', value: 'app_65ace6b435714ee88d4d9806d49240f5' }];
      // commit('SAVE_STATE', { systemList: data });
      const body = {
        pageIndex: 1,
        pageSize: 99999,
        appStatus: -1
      };
      return new Promise(resolve => {
        ajax.post('/v1/appBase/listDropdown', body).then(res => {
          const { data } = res;
          if (data.code == 200) {
            const list = data.data.records;
            list.forEach(e => {
              e.label = e.name;
              e.value = e.id;
            });
            commit('SAVE_STATE', {
              systemList: list
            });
            resolve({ msg: 'success' });
          } else {
            resolve({ msg: data.msg });
          }
        });
      });
    }
  }
};
